const BaseComponent = require('base/base-component');
const Util = require('helper/util');

class sasacGoTop extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .gotop': 'gotopEvent'
      }
    });
  }

  init () {
    this.$elLayout = this.$el.find('.gotop');
    this.$container = this.$el.find('.gotop-box');
    this.flag = true;
    let that = this;
    const browser = Util.BrowserType();
    if (browser === 'IE8' || browser === '0') {
      that.$container.slideDown('fast', () => { that.flag = false; });
    } else {
      $(window).on('scroll', () => {
        const _scrollTop = $(document).scrollTop();
        if (_scrollTop > 1 && that.flag) {
          that.$container.slideDown('fast', () => { that.flag = false; });
        } else if (_scrollTop <= 1 && !that.flag) {
          that.$container.slideUp('fast', () => { that.flag = true; });
        }
      });
    }
  }
  gotopEvent () {
    $('html , body').animate({ scrollTop: 0 }, 300);
  }
}
module.exports = sasacGoTop;
